export const getUserInfo = 'getUserInfo'
export const logout = 'logout'
export const setSessionID = 'setSessionID'
export const setToken = 'setToken'